import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import MotifIcon from '@ey/motif-react-wrapper/Icon';
import {navigationIcClose24px} from '@ey/motif-react-wrapper/assets/icons';
import Ellipse from '@ey/canvascoreservices/Ellipse';

import {labels} from '../../../util/utils';
import Icon from '@ey/canvascoreservices/Icon';
import {MotifNavigationIcClose24px} from '@ey-xd/motif-icon';

import Chip from '../../CoreWrappers/Chip';

const FilterChips = ({filters}) => {
	const renderFilter = ({categoryLabel, serieLabel = null, onClearChip = null}, i) => {
		let text = categoryLabel;
		if (!!serieLabel) text = `${text} - ${serieLabel}`;

		const props = {
			interactive: true,
			type: 'outlined',
			onClick: () => null
		};

		if (onClearChip) props.onClick = onClearChip;

		return (
			<StyledFilter {...props} key={i}>
				{text}
				<Icon src={MotifNavigationIcClose24px} />
			</StyledFilter>
		);
	};

	return filters.map(renderFilter);
};

export default FilterChips;

FilterChips.defaultProps = {
	filterChips: []
};

FilterChips.propTypes = {
	filterChips: PropTypes.arrayOf(PropTypes.object)
};

const StyledFilter = styled(Chip)`
	.motif-icon {
		--size: var(--px-14);
	}
`;
